<template lang="pug">
  .component-driver-group
    .row
      .column
        .label.pb-0 Group
        .field.m-0 G{{item.id}} {{item.name}}
      .column
        .label Policies
        .field.m-0 {{item.policies.length}}
      .column
        .label Supervisor
        br
        input(type="checkbox", v-model="item.supervisor", @change="$emit('toggleSupervisor', item)")
      .column.shrink
        dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'bottom'")
          DriverGroupButtons(:item="item", :driver="driver")

</template>

<script>
  import CardN from '../structure/CardN'
  import Dropdown from '../structure/foundation/Dropdown'
  import PolicyButtons from '../structure/ui/actions/PolicyButtons'
  import GroupButtons from '../structure/ui/actions/GroupButtons'
  import DriverGroupButtons from '../structure/ui/actions/DriverGroupButtons'

  export default {
    name: 'DriverGroup',
    components: {DriverGroupButtons, GroupButtons, PolicyButtons, Dropdown, CardN},
    props: ['item', 'driver']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// DriverGroup.vue?f8822e9a